<template>
  <div class="live-thumbnail d-flex">
    <img v-if="thumbnail" :src="thumbnail" :alt="video.title" role="button" class="w-100" @click="$emit('selected')" />

    <div v-else :id="'live-thumbnail-container-' + video.id" class="live-thumbnail-container rounded p-3 h-100" role="button" @click="$emit('selected')">
      <div class="row">
        <div class="col-6 col-lg-7">
          <b-img src="/static/img/live/live_stream_badge.png" fluid class="live-badge" />
          <h3 class="my-0 video-title">{{ video.title }}</h3>

          <h5 class="my-0 mt-4 p-0 video-speaker">{{ video.speaker.name }}</h5>

          <p class="my-0 mt-3 video-content">{{ video.content }}</p>
        </div>
        <div class="col-6 col-lg-5">
          <div class="position-relative text-right">
            <b-img :src="speakerImage" :alt="video.speaker.name" class="rounded-circle ml-auto shadow speaker-image" fluid />
            <b-img src="/static/logo.png" fluid width="50px" class="live-logo-badge" />
          </div>
          <div class="time-container pt-3 float-right">
            <div class="d-flex mt-4 justify-content-center align-items-center">
              <b-img src="/static/img/live/live_clock.png" class="clock-image" fluid />
              <div class="text-left ml-2">
                <div class="text-size-lg font-weight-bold date-text">{{ dayOfTheWeek }}</div>
                <div class="font-weight-bold date-text">{{ dateTime }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: ['video'],
  mounted() {
    console.log(this.video.timing);
  },
  computed: {
    thumbnail() {
      return this.video.attachment ? this.video.attachment.url : null;
    },
    speakerImage() {
      return this.video.speaker.image ? this.video.speaker.image.url : '/static/blank_profile.jpg';
    },
    dayOfTheWeek() {
      return this.getLocalTime().format('dddd');
    },
    dateTime() {
      return this.getLocalTime().format('MMM DD - hh:mm A');
    },
  },
  methods: {
    getLocalTime(video) {
      return moment
        .utc(this.video.start)
        .local();
    },
  },
};
</script>

<style scoped lang="scss">
.live-thumbnail {
  .live-badge {
    // position: absolute;
    // top: -1.12rem;
  }

  .speaker-image {
    width: 80%;
  }

  .live-logo-badge {
    position: absolute;
    top: 70%;
    right: 50%;
  }

  .clock-image {
    height: 40px;
    width: 40px;
    margin-right: 0.45rem;
  }

  .video-title {
    font-size: 26px;
    line-height: 26px;
  }

  .video-speaker {
    font-size: 16px;
    line-height: 19px;
  }

  .video-content {
    font-size: 12px;
    line-height: 15px;
  }

  .date-text {
    color: #0e32b1;
    font-family: Inter, sans-serif;
    font-weight: 800;
    &:first-child {
      font-size: 19px;
      line-height: 20px;
    }

    &:last-child {
      font-size: 10px;
      line-height: 20px;
    }
  }
}

@media screen and (max-width: 600px) {
  .time-container {
    margin-top: 1rem;
    .clock-image {
      height: 25px;
      width: 25px;
    }
    .date-text {
      &:first-child {
        font-size: 16px;
      }

      &:last-child {
        font-size: 9px;
      }
    }
  }
}

@media screen and (max-width: 800px) {
  .time-container {
    margin-top: 1rem;
    .clock-image {
      height: 25px;
      width: 25px;
    }
    .date-text {
      &:first-child {
        font-size: 16px;
      }

      &:last-child {
        font-size: 9px;
      }
    }
  }
}

@media screen and (max-width: 992px) {
  .time-container {
    margin-top: 1rem;
    .clock-image {
      height: 20px;
      width: 20px;
    }
    .date-text {
      &:first-child {
        font-size: 14px;
      }

      &:last-child {
        font-size: 8px;
      }
    }
  }
}

@media screen and (max-width: 1100px) {
  .time-container {
    margin-top: 1rem;
    .clock-image {
      height: 30px;
      width: 30px;
    }
    .date-text {
      &:first-child {
        font-size: 18px;
      }

      &:last-child {
        font-size: 10px;
      }
    }
  }
}

@media screen and (max-width: 1300px) {
  .time-container {
    margin-top: 1rem;
    .clock-image {
      height: 30px;
      width: 30px;
    }
    .date-text {
      &:first-child {
        font-size: 18px;
      }

      &:last-child {
        font-size: 10px;
      }
    }
  }
}
</style>
